import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postHostStream = async (payload) => {
  const { data } = await SigliveServiceV1({
    method: 'POST',
    url: `/monitoring-host/streams`,
    data: payload,
  });

  return data?.data;
};

export default postHostStream;
